module.exports = __webpack_public_path__ + "static/media/bkst_site_sell-books_header.19c3c484.jpg";